// Day Mappings Redux Dux

// Action Types
export const FETCH_DAY_MAPPINGS = "FETCH_DAY_MAPPINGS";
export const FETCH_DAY_MAPPINGS_SUCCESS = "FETCH_DAY_MAPPINGS_SUCCESS";
export const FETCH_DAY_MAPPINGS_ERROR = "FETCH_DAY_MAPPINGS_ERROR";

export const UPDATE_DAY_MAPPINGS = "UPDATE_DAY_MAPPINGS";
export const UPDATE_DAY_MAPPINGS_SUCCESS = "UPDATE_DAY_MAPPINGS_SUCCESS";
export const UPDATE_DAY_MAPPINGS_ERROR = "UPDATE_DAY_MAPPINGS_ERROR";

export const RESET_DAY_MAPPINGS = "RESET_DAY_MAPPINGS";
export const RESET_DAY_MAPPINGS_SUCCESS = "RESET_DAY_MAPPINGS_SUCCESS";
export const RESET_DAY_MAPPINGS_ERROR = "RESET_DAY_MAPPINGS_ERROR";

export const SET_LOCAL_DAY_MAPPINGS = "SET_LOCAL_DAY_MAPPINGS";

// Action Creators
export const fetchDayMappings = (location) => ({
  type: FETCH_DAY_MAPPINGS,
  payload: { location },
});

export const fetchDayMappingsSuccess = (dayMappings) => ({
  type: FETCH_DAY_MAPPINGS_SUCCESS,
  payload: dayMappings,
});

export const fetchDayMappingsError = (error) => ({
  type: FETCH_DAY_MAPPINGS_ERROR,
  payload: error,
});

export const updateDayMappings = (location, dayMappings) => ({
  type: UPDATE_DAY_MAPPINGS,
  payload: { location, dayMappings },
});

export const updateDayMappingsSuccess = (dayMappings) => ({
  type: UPDATE_DAY_MAPPINGS_SUCCESS,
  payload: dayMappings,
});

export const updateDayMappingsError = (error) => ({
  type: UPDATE_DAY_MAPPINGS_ERROR,
  payload: error,
});

export const resetDayMappings = (location) => ({
  type: RESET_DAY_MAPPINGS,
  payload: { location },
});

export const resetDayMappingsSuccess = (dayMappings) => ({
  type: RESET_DAY_MAPPINGS_SUCCESS,
  payload: dayMappings,
});

export const resetDayMappingsError = (error) => ({
  type: RESET_DAY_MAPPINGS_ERROR,
  payload: error,
});

export const setLocalDayMappings = (dayMappings) => ({
  type: SET_LOCAL_DAY_MAPPINGS,
  payload: dayMappings,
});

// Initial State
const initialState = {
  dayMappings: {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: true,
    sunday: true,
  },
  loading: false,
  error: null,
  lastUpdated: null,
};

// Reducer
export const dayMappingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAY_MAPPINGS:
    case UPDATE_DAY_MAPPINGS:
    case RESET_DAY_MAPPINGS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DAY_MAPPINGS_SUCCESS:
    case UPDATE_DAY_MAPPINGS_SUCCESS:
    case RESET_DAY_MAPPINGS_SUCCESS:
      return {
        ...state,
        dayMappings: action.payload,
        loading: false,
        error: null,
        lastUpdated: new Date().toISOString(),
      };

    case FETCH_DAY_MAPPINGS_ERROR:
    case UPDATE_DAY_MAPPINGS_ERROR:
    case RESET_DAY_MAPPINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SET_LOCAL_DAY_MAPPINGS:
      return {
        ...state,
        dayMappings: action.payload,
      };

    default:
      return state;
  }
};

// Default export for the reducer
export default dayMappingsReducer;
